import routerApps from "@/tenant/NLS/route/apps"
import routerLogin from "@/router/route/login.js"
import routerExternal from "@/tenant/NLS/route/external.js"

const routes = [
    ...routerApps,
    ...routerLogin,
    ...routerExternal,
]
export {
    routes
};
